import { BASE_URL, BUSINESS_NAME } from "@/core/constants/business";

export const META = {
  title: `Cannabis Blog | ${BUSINESS_NAME} - Marijuana News & Information`,
  meta_description:
    "Explore SLS Dispensary's blog for the latest cannabis news, marijuana guides, product reviews, and industry insights. Your trusted source for quality cannabis information in Washington DC and Maryland.",
  canonicalUrl: "/blog",
  keywords:
    "cannabis blog, marijuana guides, weed news, cannabis education, SLS Dispensary blog, Washington DC cannabis, Maryland dispensary",
  ogImage: `${BASE_URL}/images/website/street-lawyer-services-weed-dispensary-dc-75.jpg`,
};
